module.exports = __webpack_public_path__ + "static/img/icon_zhifubao.ed713246.png";